import CustomerView from 'models/location/customer_view';
import ExternalAppCardData from 'models/external_apps/external_app_card_data';
import requestCustomerExtension from 'actions/external_customer_lookup/request_customer_extension';
import RequestAppCardData from 'actions/external_apps/request_app_card_data';

export default class RefreshExternalCustomerData {
  constructor(context) {
    this.context = context;
  }

  // Refreshes `customerId` when given, otherwise the customer currently viewed.
  run({ customerId, shouldRequestAppDataRefresh, shouldRequestCustomerExtension }) {
    const targetCustomerId = customerId || this.currentCustomerId();
    if (!targetCustomerId) {
      return;
    }

    if (shouldRequestCustomerExtension) {
      requestCustomerExtension(this.context, targetCustomerId);
    }

    if (shouldRequestAppDataRefresh) {
      this.context.executeAction(RequestAppCardData, {
        gladlyEntityId: targetCustomerId,
        gladlyEntityType: ExternalAppCardData.EntityType.CUSTOMER,
        forceDataRefresh: true,
      });
    }

    this.context.analytics.track('Customer Profile Data Refreshed', {
      customerId: targetCustomerId,
    });
  }

  currentCustomerId() {
    const currentLocation = this.context.stores.currentLocation.get();
    return currentLocation instanceof CustomerView ? currentLocation.customerId : undefined;
  }
}
